import { render, staticRenderFns } from "./Solicitacao.vue?vue&type=template&id=72277ddf&"
import script from "./Solicitacao.vue?vue&type=script&lang=js&"
export * from "./Solicitacao.vue?vue&type=script&lang=js&"
import style0 from "./Solicitacao.vue?vue&type=style&index=0&id=72277ddf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports